<template>
  <div class="d-flex"
       style="width: 100%;">
    <template v-if="canUseBookmarks && canBeBookmarked">
      <v-btn @click.prevent="toggleBookmark"
             :disabled="bookmarkBusy"
             :title="isBookmarked ? 'Remove from favorites' : 'Add to favorites'"
             icon>
        <v-icon v-if="bookmarkBusy">
          fal fa-spin fa-spinner
        </v-icon>
        <v-icon v-else-if="isBookmarked">
          fas fa-bookmark
        </v-icon>
        <v-icon v-else>
          fal fa-bookmark
        </v-icon>
      </v-btn>
    </template>
    <v-menu offset-y
            v-if="canBePresented && canBeOpened">
      <template v-slot:activator="{on, attrs}">
        <v-btn icon
               v-bind="attrs"
               v-on="on">
          <v-icon>
            fal fa-presentation
          </v-icon>
        </v-btn>
      </template>
      <open-presentation-menu-list :presentation="presentation">
      </open-presentation-menu-list>
    </v-menu>
    <v-btn v-if="canUsePresentationNotes && presentation.num_pages > 0"
           :to="{name: `${$root.routePrefix}.presentation.notes`, params: {presentationID: presentation.id}}"
           icon
           title="My notes">
      <v-icon>
        fal fa-sticky-note
      </v-icon>
    </v-btn>
    <v-menu v-if="(canUseDownload && exportURL) || (canUsePrint && printURL) || canUseInsights || canBeHandout"
            offset-y>
      <template v-slot:activator="{on, attrs}">
        <v-btn icon
               v-on="on"
               v-bind="attrs">
          <v-icon>
            fal fa-ellipsis-v
          </v-icon>
        </v-btn>
      </template>
      <v-list dense>
        <v-list-item v-if="canUseDownload && exportURL"
                     @click.prevent="exportPresentation">
          <v-list-item-icon class="me-2">
            <v-icon>
              fal fa-fw fa-download
            </v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>
              Download this file
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item v-if="canBeHandout"
                     :href="`${presentation.handout_url}`"
                     target="_blank">
          <v-list-item-icon class="me-2">
            <v-icon>
              fal fa-fw fa-file-alt
            </v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>
              Print Handout
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item v-if="canUsePrint && printURL"
                     @click.prevent="printPresentation">
          <v-list-item-icon class="me-2">
            <v-icon>
              fal fa-fw fa-print
            </v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>
              Print this file
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item v-if="canUseInsights"
                     :to="{name: 'library.presentation.activity', params: {presentationID: presentation.id}}">
          <v-list-item-icon class="me-2">
            <v-icon>
              fal fa-fw fa-lightbulb-on
            </v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>
              View Insights
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-menu>
    <v-btn v-if="1===2 && canUseDownload && exportURL"
           @click.prevent="exportPresentation"
           class="ml-0"
           :disabled="exportBusy"
           title="Save this file to your computer"
           icon>
      <v-icon v-if="exportBusy">
        fal fa-spin fa-spinner
      </v-icon>
      <v-icon v-else>
        fal fa-download
      </v-icon>
    </v-btn>
    <v-btn v-if="1===2 && canUsePrint && printURL"
           @click.prevent="printPresentation"
           class="ml-0"
           :disabled="printBusy"
           title="Print this file"
           icon>
      <v-icon v-if="printBusy">
        fal fa-spin fa-spinner
      </v-icon>
      <v-icon v-else>
        fal fa-print
      </v-icon>
    </v-btn>
    <v-btn v-if="1===2 && canUseInsights"
           :to="{name: 'library.presentation.activity', params: {presentationID: presentation.id}}"
           class="ml-0"
           icon
           title="Insights">
      <v-icon>
        fal fa-lightbulb-on
      </v-icon>
    </v-btn>
    <v-spacer></v-spacer>
    <template v-if="canBeFaxed || canBeEmailed">
      <v-menu offset-y>
        <template v-slot:activator="{on, attrs}">
          <v-btn v-bind="attrs"
                 v-on="on"
                 icon>
            <v-icon>
              fal fa-paper-plane
            </v-icon>
          </v-btn>
        </template>
        <v-list dense>
          <v-list-item v-if="canBeSentViaEmailTemplate && team.id !== 276"
                       :to="{name: 'library.email.wizard', query: {presentationID: presentation.id, redirect: 'back'}}"
                       dense>
            <v-list-item-icon>
              <v-icon>
                fal fa-fw fa-paper-plane
              </v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>
                Send Email
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item v-if="canBeQuickSharedFromBrowser"
                       @click.prevent="showQuickShareDialog = true"
                       dense>
            <v-list-item-icon>
              <v-icon>
                fal fa-fw fa-share
              </v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>
                Quick Share
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item v-if="canTeamQuickShareLink"
                       @click.prevent="openCreateLinkDialog"
                       dense>
            <v-list-item-icon>
              <v-icon>
                fal fa-fw fa-copy
              </v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>
                Create Link
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item v-if="canBeFaxed"
                       :to="{name: 'library.send_fax', query: {presentation_id: presentation.id}}"
                       dense>
            <v-list-item-icon>
              <v-icon>
                fal fa-fw fa-fax
              </v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>
                Send Fax
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-menu>
    </template>

    <QuickShareDialog v-if="showQuickShareDialog"
                      :presentation="presentation"
                      :dialog="showQuickShareDialog"
                      @close="showQuickShareDialog = false">
    </QuickShareDialog>

    <CreateSharedLinkDialog v-if="showCreateLinkDialog"
                            :presentation="presentation"
                            :dialog="showCreateLinkDialog"
                            @close="closeCreateLinkDialog">
    </CreateSharedLinkDialog>


  </div>
</template>
<script>
import {mapGetters} from 'vuex';
import {find} from 'lodash';
import axios from '../../../services/axiosService';
import presentationService from '../../../../../ml/services/presentationService';
import printJS from 'print-js';
import OpenPresentationMenuList from "./OpenPresentationMenuList";
import QuickShareDialog from "./QuickShareDialog";
import CreateSharedLinkDialog from './CreateSharedLinkDialog.vue';

export default {
  components: {CreateSharedLinkDialog, QuickShareDialog, OpenPresentationMenuList},
  props: {
    presentation: {
      type: Object,
      required: true,
    }
  },
  data() {
    return {
      bookmarkBusy: false,
      exportBusy: false, // MLD-2673
      printBusy: false, // MLD-2762
      showQuickShareDialog: false, // MLD-3277
      showCreateLinkDialog: false, // MLD-7622
    }
  },
  computed: {
    ...mapGetters([
      'agent', // MLD-3019
      'canSendEmail', // MLD-3917
      'canSendFaxes', // MLD-4538
      'canTeamQuickShareLink', // MLD-7622
      'canUsePresentationNotes', // MLD-6435
      'isAdmin',
      'isFullUser', // MLD-4153
      'isMember', // MLD-3766
      'isUserInUnitedStates', // MLD-4153
      'team',
      'user',
    ]),
    ...mapGetters('content', [
      'bookmarks',
      'bookmarkedPresentations',
      'liveMode',
      'templates', // MLD-5082
    ]),
    canUseBookmarks() { // MLD-2750
      return this.isFullUser;
    },
    canUseDownload() { // MLD-2750
      return this.isFullUser;
    },
    canBeHandout() { // MLD-6661
      return this.team
        && this.team.presentation_handouts_enabled
        && this.presentation
        && this.presentation.settings.can_be_handout
        && this.isPDF;
    },
    canUsePrint() { // MLD-2750
      return this.isFullUser;
    },
    canUseInsights() { // MLD-2750
      if (this.isZIP) { // MLD-5606
        return false;
      }
      if (this.isFullUser && this.presentation && this.presentation.settings && (this.presentation.settings.can_be_shared || this.presentation.settings.can_be_shared_link)) {
        return true;
      }
      return false;
    },
    isBookmarked() {
      return this.bookmarkedPresentations.includes(this.presentation.id);
    },
    canBeBookmarked() { // MLD-2107
      return this.team.bookmarks_enabled;
    },
    canBePresented() {
      return !!this.presentation.settings.can_be_presented_by_user;
    },
    canBeOpened() {
      if (this.isZIP) { // MLD-5606
        return false;
      }
      if (this.isHTML) { // MLD-2254
        return this.team.is_content_domain_enabled
          && this.presentation.settings.can_user_use_cdn;
      }
      return !this.isHTML;
    },
    template() { // MLD-5082
      if (this.presentation && this.presentation.share_template_id) {
        return find(this.templates, t => t.id === this.presentation.share_template_id);
      }
      return null;
    },
    canBeSentViaEmailTemplate() { // MLD-5082
      // Incyte (Team 65) uses attachments on email templates.
      // If the presentation is associated with an email template that uses attachments,
      // it cannot be sent via email template.
      if (this.team?.id === 65 && this.template) {
        return this.canBeEmailed
          && this.presentation.is_template_required === false // MLD-5082 on 2023-09-06
          && this.template.attach_file === false;
      }
      return this.canBeEmailed;
    },
    canBeEmailed() {
      return this.canSendEmail
        && this.presentation.settings.can_be_shared;
    },
    canBeQuickSharedFromBrowser() { // MLD-3277
      return this.canBeEmailed
        && this.team.quickshare_browser_enabled;
    },
    canBeFaxed() { // MLD-3298
      return this.canSendFaxes
        && this.presentation.can_be_faxed;
    },
    isURL() {
      return this.presentation.type_url;
    },
    isPDF() { // MLD-7352
      return this.presentation.type_pdf
        || this.presentation.converts_to_pdf;
    },
    isHTML() {
      return this.presentation.type_html;
    },
    isZIP() { // MLD-5606
      return this.presentation?.type_zip;
    },
    canBeExported() { // MLD-2673
      if (this.presentation) {
        if (this.isZIP) { // MLD-5606
          return true;
        }
        return this.isHTML === false
          && this.isURL === false
          && !!this.presentation.settings.can_be_exported;
      }
      return false;
    },
    canBePrinted() {
      return this.presentation
        && (this.presentation.type_pdf || this.presentation.converts_to_pdf)
        && !!this.presentation.settings.can_be_printed_by_user;
    },
    exportURL() { // MLD-2673
      if (this.canBeExported) {
        return `/api/presentations/${this.presentation.id}/file/export`;
      }
      return null;
    },
    printURL() { // MLD-2672
      if (this.canBePrinted) {
        return `/api/presentations/${this.presentation.id}/file/print`;
      }
      return null;
    }
  },
  methods: {
    async toggleBookmark() { // MLD-2107
      if (this.bookmarkBusy) {
        return;
      }
      try {
        this.bookmarkBusy = true;
        await this.$store.dispatch('content/toggleBookmark', this.presentation.id);
      } catch (err) {

      } finally {
        this.bookmarkBusy = false;
      }
    },
    async exportPresentation() { // MLD-2673
      if (this.exportBusy) {
        return false;
      }
      if (!this.exportURL) {
        return false;
      }
      this.exportBusy = true;
      try {
        const {data: file} = await axios.get(this.exportURL);
        if (file && file.url) {
          await presentationService.downloadFile(this.presentation, file);
        }
        return false;
      } catch {

      } finally {
        this.exportBusy = false;
      }
    },
    async printPresentation() { // MLD-2672
      if (this.printBusy) {
        return false;
      }
      if (!this.printURL) {
        return false;
      }
      this.printBusy = true;
      try {
        const {data: file} = await axios.get(this.printURL);
        if (file && file.url) {
          await this.printFromURL(file.url);
        }
        return false;
      } catch {
        this.printBusy = false;
      }
    },
    async printFromURL(url) {
      //console.log('print', url);
      // @see https://jetrockets.pro/blog/l8dadq8oac-how-to-download-files-with-axios
      const axiosConfig = {
        responseType: 'blob',
        withCredentials: false,
      };
      const {data} = await axios.get(url, axiosConfig)
      const pdfURL = URL.createObjectURL(new Blob([data]));

      // @see https://printjs.crabbly.com/#documentation
      const pdfConfig = {
        printable: pdfURL,
        documentTitle: this.presentation.name,
        onLoadingStart: () => {
          //console.log('onLoadingStart()');
        },
        onLoadingEnd: () => {
          //console.log('onLoadingEnd()');
          this.printBusy = false;
        },
        onPrintDialogClose: () => {
          //console.log('onPrintDialogClose()');
          this.printBusy = false;
        },
        onError: (err) => {
          //console.log('printJS onError()', err);
          this.printBusy = false;
        },
      }
      printJS(pdfConfig);
    },
    openCreateLinkDialog() { // MLD-7622
      this.showCreateLinkDialog = true;
    },
    closeCreateLinkDialog() { // MLD-7622
      this.showCreateLinkDialog = false;
    }
  }
}
</script>
